import { render } from "./FormSubmitButton.vue?vue&type=template&id=9888a998"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js"
script.render = render

export default script